import { ToastService } from './../../../../core/toast.service';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject, Subscription } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Filter } from 'src/app/core/models/filter';
import { SupplyFavorites } from '../../models/supply-favorites';
import { DeleteSupplyFavoritesService } from '../../services/delete-supply-favorites.service';
import { GetSupplyFavoritesService } from './../../services/get-supply-favorites.service';
import { LoginService } from 'src/app/core/services/login.service';
import { CatFavService } from '../../services/cat-fav.service';

@Component({
  selector: 'app-my-favourites',
  templateUrl: './my-favourites.component.html',
  styleUrls: ['./my-favourites.component.scss']
})
export class MyFavouritesComponent implements OnInit, AfterViewInit, OnDestroy {

  /* --------------------------------- Fields --------------------------------- */
filterForm = this.fb.group({
  search: ['', [Validators.required]],
  limit: [10, [Validators.required]],
  offset: [0,[Validators.required]]
});

filterFormc = this.fb.group({
  search: ['', [Validators.required]],
  limitc: [10, [Validators.required]],
  offsetc: [0,[Validators.required]]
});

totalElements = 0;
filterSubject: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterForm.value);

totalElementsc = 0;
filterSubjectc: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterFormc.value);

supplyFavoritesList: SupplyFavorites[];
subscription: Subscription;
loginDetals:any;
userCats:any;
CatalogIds = [];
favCats:any;
/* ------------------------------- Constructor ------------------------------ */

  constructor(
    private fb: FormBuilder,
    private matDialog: MatDialog,
    private getSupplyFavoritesService: GetSupplyFavoritesService,
    private deleteSupplyFavoritesService: DeleteSupplyFavoritesService,
    private toast: ToastService,
    private loginService:LoginService,
    private catFavService:CatFavService
  ) { }


/* ---------------------------- Life cycle hooks ---------------------------- */

  ngOnInit(): void {

   this.loginDetals = this.loginService.getLoginData()

   console.log(this.loginDetals)

   if(this.loginDetals.type == "SUPPLIER"){

    this.catFavService.getFaveSuplier(this.loginDetals.id).subscribe(data=>{
      console.log(data)
      this.userCats = data
      this.userCats = this.userCats.sort(function (a, b) {
        //return b.created_at.toDate() - a.created_at.toDate()
        //return b.created_at.getTime() - a.created_at.getTime();
        var c:any = new Date(a.created_at);
            var d:any = new Date(b.created_at);
            return d-c;
      });
      // for(let catIds of this.userCats){
      //   this.CatalogIds.push(catIds.catalogue_id)
      // }
      // this.catFavService.getFavCats(this.CatalogIds).subscribe(data=>{
      //   console.log(data)
      //   this.favCats = data
      // })

    })

   }

   if(this.loginDetals.type == "PROFESSIONAL"){

    this.catFavService.getFavProfessional(this.loginDetals.id).subscribe(data=>{
      console.log(data)
      this.userCats = data
      this.userCats = this.userCats.sort(function (a, b) {
        //return b.created_at.toDate() - a.created_at.toDate()
        //return b.created_at.getTime() - a.created_at.getTime();
        var c:any = new Date(a.created_at);
            var d:any = new Date(b.created_at);
            return d-c;
      });
      // for(let catIds of this.userCats){
      //   this.CatalogIds.push(catIds.catalogue_id)
      // }
      // this.catFavService.getFavCats(this.CatalogIds).subscribe(data=>{
      //   console.log(data)
      //   this.favCats = data
      // })


    })

  }

  if(this.loginDetals.type == "PRACTICE"){

    this.catFavService.getFavPracice(this.loginDetals.id).subscribe(data=>{
      console.log(data)

      this.userCats = data
      this.userCats = this.userCats.sort(function (a, b) {
        //return b.created_at.toDate() - a.created_at.toDate()
        //return b.created_at.getTime() - a.created_at.getTime();
        var c:any = new Date(a.created_at);
            var d:any = new Date(b.created_at);
            return d-c;
      });
      // this.CatalogIds = []
      // for(let catIds of this.userCats){
      //   this.CatalogIds.push(catIds.catalogue_id)
      // }
      // //console.log()
      // this.catFavService.getFavCats(this.CatalogIds).subscribe(data=>{
      //   console.log(data)
      //   this.favCats = data
      // })

    })

  }

    this.subscription = this.filterSubject.pipe(switchMap(filter=>{
      this.supplyFavoritesList = null;
      return this.getSupplyFavoritesService.getSupplyFavorites(filter);
    })).subscribe(([supply_favorites, count]:[SupplyFavorites[], number])=> {
      this.supplyFavoritesList = supply_favorites;
      console.log(this.supplyFavoritesList);
      this.totalElements = count;
    });

  }


  ngAfterViewInit(): void {

  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }


/* --------------------------------- Getters -------------------------------- */

get search(): AbstractControl {
  return this.filterForm.get("search");
}
get limit(): AbstractControl {
  return this.filterForm.get('limit');
}
get offset(): AbstractControl {
  return this.filterForm.get('offset');
}

get limitc(): AbstractControl {
  return this.filterFormc.get('limitc');
}
get offsetc(): AbstractControl {
  return this.filterFormc.get('offsetc');
}

changePage(e: PageEvent){
  this.offset.setValue(e.pageSize * e.pageIndex);
  this.filterSubject.next(this.filterForm.value);
}

changePagec(e: PageEvent){
  this.offsetc.setValue(e.pageSize * e.pageIndex);
  this.filterSubjectc.next(this.filterFormc.value);
}

deleteCatsFavorites(single){

  console.log(single)

  this.catFavService.removeCat(single.id).subscribe(data=>{
    console.log(data)

  })

}

productRemoved(ev: any){
  this.filterSubject.next(this.filterForm.value);
}



}
